e4.scrollToAnchor = {
    init: function () {
        e4.scrollToAnchor.animating = false;
        e4.scrollToAnchor.goToLocationHash();
        e4.scrollToAnchor.bindEvents();
        e4.scrollToAnchor.backToTop.init();
    },
    goToLocationHash: function () {
        if ( e4.util.hash.getCurrentHashStringValue() !== '' && location.hash.indexOf( '/' ) === -1 ) {
            var intScrollTarget = e4.scrollToAnchor.getTarget( location.hash );
            if ( intScrollTarget > -1 ) {
                e4.scrollToAnchor.animate( intScrollTarget );
                e4.nav.global.hide();
            }
        }
    },
    bindEvents: function () {
        jQuery( 'a[href*="#"]' ).not( 'a[data-toggle],a[data-slide]' ).on( 'click', function ( event ) {
            if ( this.hash === '#top' ) {
                event.preventDefault();
                e4.scrollToAnchor.animate( 0 );
            }
            else if ( location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' ) && location.hostname === this.hostname ) {
                event.preventDefault();
                e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( this.hash ) );
            }
        } );
    },
    getTarget: function ( selector ) {
        var jWindow = jQuery( window ),
            jTarget = jQuery( selector ),
            jTargetSection = jTarget.closest( '.e-section' ),
            intScrollTarget = -1;
        if ( jTarget.length === 1 ) {
            if ( jTargetSection.is( e4.settings.scrollReveal.selector ) === true ) {
                jTargetSection.addClass( e4.settings.scrollReveal.classResetAnimate );
            }
            intScrollTarget = jTarget.offset().top;
            if ( jTargetSection.is( e4.settings.scrollToAnchor.fullscreenElements ) === false ) {
                intScrollTarget -= jWindow.height() / 100 * e4.settings.scrollToAnchor.nudge;
            }
            // if ( jQuery( '.js-e-page-auto-hide-menu' ).length === 1 ) {
            //     e4.settings.scrollToAnchor.stickyElements = e4.settings.scrollToAnchor.stickyElements.replace( '.js-e-header.is-sticky', '' );
            // }
            jQuery( e4.settings.scrollToAnchor.stickyElements ).each( function () {
                intScrollTarget -= jQuery( this ).height();
            } );
            intScrollTarget = Math.max( intScrollTarget, 0 );
        }
        return intScrollTarget;
    },
    animate: function ( intScrollTarget, callback ) {
        if ( intScrollTarget > -1 ) {
            if ( e4.scrollToAnchor.animating === false ) {
                e4.scrollToAnchor.animating = true;
                jQuery( 'html,body' ).animate( {
                    scrollTop: intScrollTarget
                }, Math.floor( Math.abs( jQuery( window ).scrollTop() - intScrollTarget ) * e4.settings.scrollToAnchor.speed ), e4.settings.scrollToAnchor.easing, function () {
                    e4.scrollToAnchor.animating = false;
                    if ( typeof callback === 'function' ) {
                        callback();
                    }
                } );
            }
        }
    },
    backToTop: {
        init: function () {
            if ( jQuery( '.js-e-page-back-to-top' ).length === 1 ) {
                e4.scrollToAnchor.backToTop.requestingAnimation = false;
                e4.scrollToAnchor.backToTop.bindEvents();
            }
        },
        bindEvents: function () {
            jQuery( window ).on( 'scroll resize', function () {
                if ( e4.scrollToAnchor.backToTop.requestingAnimation === false ) {
                    window.requestAnimationFrame( function () {
                        e4.scrollToAnchor.backToTop.toggleVisibility();
                        e4.scrollToAnchor.backToTop.requestingAnimation = false;
                    } );
                }
                e4.scrollToAnchor.backToTop.requestingAnimation = true;
            } );
        },
        toggleVisibility: function () {
            var jWindow = jQuery( window ),
                windowScrollTop = jWindow.scrollTop(),
                jBackToTopLink = jQuery( '.js-e-back-to-top' );
            e4.scrollToAnchor.scrollDirectionCurrent = windowScrollTop > e4.scrollToAnchor.lastScrollTop ? 'down' : 'up';
            if ( e4.scrollToAnchor.scrollDirectionCurrent !== e4.scrollToAnchor.scrollDirectionNew ) {
                if ( windowScrollTop > jWindow.height() * e4.settings.scrollToAnchor.backToTop.revealOffset ) {
                    jBackToTopLink.addClass( 'is-visible' );
                }
                else {
                    jBackToTopLink.removeClass( 'is-visible' );
                }
            }
            e4.scrollToAnchor.scrollDirectionLast = e4.scrollToAnchor.scrollDirectionCurrent;
        }
    }
};

